import React from 'react';
import withSEO from 'Hoc/withSEO';
import Page5XXV3 from './5XXV3';

const Page503V3: React.FC = () => (
  <Page5XXV3
    title="Service Unavailable"
    text="One of our services seems to be down. Our team has already been notified about it."
  />
);

export default withSEO({ title: 'Service Unavailable' })(Page503V3);
